import { updateReady } from '../state/store';

/** "New version / new content available" with a reload button (F12). */
export function UpdatePrompt() {
  const kind = updateReady.value;
  if (!kind) return null;
  const reload = () => void import('../pwa/register').then((m) => m.reloadForUpdate()).catch(() => location.reload());
  return (
    <div class="update-prompt" role="status" data-testid="update-prompt" data-kind={kind}>
      <span>{kind === 'app' ? 'A new version of the atlas is ready.' : 'New content available.'}</span>
      <button type="button" class="btn small primary" onClick={reload} data-testid="update-reload">Reload</button>
      <button type="button" class="btn small ghost" onClick={() => (updateReady.value = null)} aria-label="Dismiss">Later</button>
    </div>
  );
}
